import React, { useState } from 'react';
import {
  getBannerAnimationClass,
  getButtonVariantsData,
  useGetAlignments,
  WithLink,
} from '../../utils';
import { twMerge } from 'tailwind-merge';
import CustomizedButton from '../../../../../WidgetMaker/WidgetDnD/WIdgetPropertiesBasic/components/Button';
import contentAnimationStyle from '@/components/DesignSystem/AtomicDesignsUtilities/ContentAnimationStyles.module.scss';
import buttonAnimationStyle from '@/components/DesignSystem/AtomicDesignsUtilities/ContentButtonAnimationStyle.module.scss';
import { btnActionHandler } from '@/components/DesignSystem/ModernTheme/utils/btnUtils';
import { RenderMediaComponent } from '@/components/DesignSystem/ModernTheme/utils/common';
import { BUTTON_SIZE_TYPE } from 'src/components/WidgetMaker/utils/buttonConstant';
import { EditableText } from '../../../RichTextImage/component/TextEditor';
import classNames from 'classnames';
import CommonLinkWrapper from '../../../CommonLinkWrapper';
import { checkIsAudioPresentInVideo } from 'src/utils/checkIsAudioPresentInVideo';
import { NextImage } from 'src/components/DesignSystem/NextImage';

export function BannerItem(props) {
  const {
    // primary props
    image,
    index,
    isNewCarousel,
    widgetOptions,
    isMobile,
    isCurrentSlideActive = false,
    // secondary props
    videoElementRefs,
    handleVideoDuration,
    setVideoElementRefs,
    globalStyle,
    shouldShiftTextContainer,
    getAdjustedShiftFromTop,
    imageWrapperComponentStyles = {},
    useDefaultHTMLTag,
  } = props;
  const [isMuted, setIsMuted] = useState(true);

  const isDesktop = !isMobile;
  const imageUrl = image.image_url || image.src;
  const oldRedirectLink = !isNewCarousel ? widgetOptions.links?.[index]?.href : '';
  const { getButtonAlignment, getContentPosition } = useGetAlignments({
    isDesktop: !isMobile,
    widgetOptions,
  });
  const bannerAnimationClass = getBannerAnimationClass?.({
    widgetOptions,
    isCurrentSlideActive,
  });
  const isVideo = image.is_video;
  const showMuteToggler =
    isVideo &&
    checkIsAudioPresentInVideo({
      videoRef: videoElementRefs?.[index],
      defaultAudioStatus: false,
    });

  function handleSoundClick() {
    setIsMuted((prev) => !prev);
  }

  function _RenderBannerImageComponent({ imageUrl, bannerMetaText }) {
    const _ImageComponent = (
      <NextImage
        src={imageUrl}
        alt={bannerMetaText}
        useDefaultHTMLTag={
          useDefaultHTMLTag || imageWrapperComponentStyles?.height === 'auto'
        }
        priority
        layout="fill"
        quality={isMobile ? 80 : 100}
        className={classNames(
          'tw-w-full tw-object-cover',
          widgetOptions?.isBannerFullWidth !== false && 'removeGlobalOverride'
        )}
      />
    );

    return (
      <div className="tw-relative" style={imageWrapperComponentStyles}>
        {_ImageComponent}
      </div>
    );
  }

  return (
    <div key={imageUrl}>
      <div
        className={classNames(
          `tw-relative tw-bg-opacity-${image?.textContent?.overlayOpacity || 20}`,
          (image?.actions?.handler || oldRedirectLink) && 'tw-cursor-pointer',
          !isNewCarousel && 'tw-h-full tw-w-full'
        )}
        onClick={() => {
          if (image?.actions?.handler) {
            btnActionHandler(image?.actions);
          }
        }}
      >
        <WithLink
          {...props}
          className="tw-h-full tw-w-full"
          redirectLink={oldRedirectLink}
        >
          <div className={twMerge('image-container', bannerAnimationClass)}>
            {imageUrl ? (
              isVideo ? (
                <RenderMediaComponent
                  mediaData={{
                    type: 'video',
                    autoplay: true,
                    hideControls: true,
                    isVideoMuted: isMuted,
                    content: [
                      {
                        url: imageUrl,
                      },
                    ],
                    showMuteUnmuteOption: true,
                    getVideoDuration: (val, isVisble) =>
                      handleVideoDuration?.(val, isVisble),
                    setMediaComponentRef: (node) => {
                      if (videoElementRefs?.[index] || !node) return;
                      if (index === 0) node.currentTime = 4;

                      setVideoElementRefs?.((els) => {
                        const newEls = [...(els || [])];
                        newEls[index] = node;
                        return newEls;
                      });
                    },
                  }}
                />
              ) : (
                _RenderBannerImageComponent({
                  imageUrl: imageUrl,
                  bannerMetaText: image?.textContent?.bannerMetaText || '',
                })
              )
            ) : (
              _RenderBannerImageComponent({
                imageUrl: 'https://cdn.dotpe.in/longtail/themes/8073865/BRuFN2JQ.webp',
                bannerMetaText: image?.textContent?.bannerMetaText || '',
              })
            )}
          </div>
        </WithLink>
        <div
          className={`tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-top-0 tw-z-[1]`}
          style={{
            background: `rgba(0,0,0, ${image?.textContent?.overlayOpacity / 100})`,
            borderRadius:
              widgetOptions?.isBannerFullWidth === false
                ? globalStyle?.imageCards?.style?.borderRadius?.split(' !important')?.[0]
                : '',
          }}
        />
        {(image?.textContent?.isShow || image.buttons?.find((btn) => btn.isShow)) &&
          isCurrentSlideActive && (
            <div
              style={{
                width: '100%',
                justifyContent: !isMobile
                  ? widgetOptions?.contentPositionDesktop
                  : 'center',
                top: `calc(50% + ${shouldShiftTextContainer ? getAdjustedShiftFromTop?.() : 0}px)`,
              }}
              className="tw-absolute tw-top-1/2 tw-z-30 tw-flex tw-min-w-[30%] tw--translate-y-1/2"
            >
              <div
                className={twMerge(
                  ` ${!isMobile ? 'tw-mx-[80px] tw-p-[52px]' : 'tw-px-[24px] tw-py-[40px]'}`,
                  isCurrentSlideActive &&
                    contentAnimationStyle[widgetOptions.contentAnimationConfig?.className]
                )}
                style={{
                  width: !isMobile ? `${image?.textContent?.width}%` || '30%' : '90%',
                  color: image?.textContent?.textColor || '#ffffff',
                  background: isCurrentSlideActive
                    ? image?.textContent?.backgroundColor
                    : 'transparent',
                }}
              >
                {image?.textContent?.isShow && (
                  <div className={twMerge('tw-z-10')}>
                    {image?.textContent?.headline ? (
                      <EditableText
                        style={{
                          textAlign: getContentPosition(),
                          fontSize: isDesktop ? 40 : 28,
                        }}
                        content={image?.textContent?.headline}
                        className={`tw-my-0 tw-font-light tw-text-${getContentPosition()} tw-text-[28px] md:tw-text-[40px] `}
                      />
                    ) : null}
                    {image?.textContent?.description ? (
                      <EditableText
                        content={image?.textContent?.description}
                        style={{
                          textAlign: getContentPosition(),
                        }}
                        className={`tw-mb-0 tw-mt-16 tw-text-16 tw-font-light tw-leading-[23px] tw-text-${getContentPosition()}`}
                      />
                    ) : null}
                  </div>
                )}
                {image?.buttons?.length && isCurrentSlideActive ? (
                  <div
                    className={twMerge(
                      `tw-mt-[36px] tw-flex tw-w-full tw-flex-col md:tw-flex-row ${getButtonAlignment?.('flex')}`,
                      isCurrentSlideActive &&
                        buttonAnimationStyle[
                          widgetOptions.contentAnimationConfig?.className
                        ]
                    )}
                    style={{
                      flexDirection: isDesktop ? 'row' : 'column',
                    }}
                  >
                    {image.buttons?.map((buttonData, btnIndex) => {
                      const buttonVariant = getButtonVariantsData(buttonData);
                      const selectedButtonType = buttonVariant[buttonData.type];
                      const link = buttonData?.actions?.handler;
                      return buttonData.isShow ? (
                        <CommonLinkWrapper
                          link={link}
                          disableLink={buttonData?.actions?.newTab}
                        >
                          <CustomizedButton
                            key={btnIndex}
                            size={BUTTON_SIZE_TYPE.LARGE}
                            btnType={buttonData.type}
                            buttonData={buttonData}
                            selectedButtonData={selectedButtonType}
                            variant={selectedButtonType.variant}
                            textualAlignment={getContentPosition()}
                            onClick={(e) => {
                              e.stopPropagation();
                              btnActionHandler(buttonData?.actions, () => {});
                            }}
                            className={twMerge(
                              `tw-rounded-none !tw-text-[16px] !tw-font-normal
                 [&>p]:!tw-text-ellipsis [&>p]:!tw-whitespace-nowrap
                  ${
                    btnIndex
                      ? isDesktop
                        ? ' !tw-ml-[25px] sm:!tw-ml-0 sm:!tw-mt-[25px] '
                        : ' !tw-mt-[14px] sm:!tw-ml-0 sm:!tw-mt-[14px] '
                      : ''
                  }
                  ${!isDesktop ? ' !tw-w-[100%]' : ''}
                  `
                            )}
                          >
                            {buttonData?.text}
                          </CustomizedButton>
                        </CommonLinkWrapper>
                      ) : null;
                    })}
                  </div>
                ) : null}
              </div>
            </div>
          )}
        {showMuteToggler && (
          <div
            onClick={handleSoundClick}
            className={classNames(
              `tw-pointer wb-sprite tw-absolute !tw-z-50 ${isMobile ? 'tw-bottom-[10px] tw-right-[10px]' : 'tw-bottom-[16px] tw-right-[16px]'}`,
              isMuted ? 'unmute-lg' : 'mute-lg'
            )}
          />
        )}
      </div>
    </div>
  );
}
